class ViewAllTabs {
  constructor() {
    this.settings = {
      viewTabs: '.js-view',
      navTabs: '.nav',
    };
  }

  init() {
    const videoSelector = $(this.settings.viewTabs);
    const $this = this;
    videoSelector.on({
      click(e) {
        e.preventDefault();
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 200);
        $this.setActiveClass(this);
      },
    });
  }

  setActiveClass(element) {
    const $element = $(element);
    const tabName = $element.attr('href') ? $element.attr('href') : false;
    const $tabs = $(this.settings.navTabs);
    if (tabName) {
      $tabs.find('li').removeClass('active');
      const $tab = $tabs.find(`a[href$='${tabName}']`);
      $tab.parent().addClass('active');
      window.scroll({ top: 600, left: 0, behavior: 'smooth' });
    }
  }
}


export default ViewAllTabs;
